﻿window.onload = function processFunction() {
    //check refund eligibility by order Number.
    $("#orderNumEligible").click(function () {
        var orderNum = $('#orderNum').val().trim();
        if (orderNum.length == 0) {
            //order number is empty.
            ShowError("Please enter a valid Order Number");
            return false;
        }

        if (!orderNum.toLowerCase().startsWith("us") && !orderNum.toLowerCase().startsWith("ced") && !orderNum.toLowerCase().startsWith("ca")) {
            //invalid order number.
            ShowError("Please enter a valid Order Number");
            return false;
        }

        PleaseWait();
        $.ajax({
            type: "Get",
            url: "https://dnext.humankinetics.com/Shopify/FAQs/refund/EligibleByOrderNum?ordernumber=" + orderNum,
            contentType: "text/javascript",
            crossDomain: true,
            timeout: 180000, //need the timeout because .fail doesn't get called for cross domain requests.
            xhrFields: { withCredentials: true }
        })
            .done(function (data) {
                HideWait();
                //call was successful.
                var objResult = jQuery.parseJSON(data);
                if (data.indexOf("Error") >= 0) {
                    //display error message.
                    ShowError(objResult.ErrorMessage);
                    return false;
                } else {
                    displayResults(objResult);
                }
            })
            .fail(function (xhr, textStatus, errorThrown) {
                HideWait();
				console.log(xhr);
				console.log(textStatus);
				console.log(errorThrown);
                //call didn't succeed.
                ShowError("Something went wrong, please try again later");
            });

        return false;

    });


    //check refund eligibility by code
    $("#codeEligible").click(function () {
        var code = $('#ebookCode').val().trim();
        if (code.length == 0) {
            //email is empty.
            ShowError("Please enter a valid code");
            return false;
        }
        PleaseWait();
        $.ajax({
            type: "Get",
            url: "https://dnext.humankinetics.com/Shopify/FAQs/refund/EligibleByCode/" + code,
            contentType: "text/javascript",
            crossDomain: true,
            timeout: 20000, //need the timeout because .fail doesn't get called for cross domain requests.
            xhrFields: { withCredentials: true }
        })
            .done(function (data) {
                HideWait();
                var objResult = jQuery.parseJSON(data);
                if (data.indexOf("Error") >= 0) {
                    //display error message.
                    ShowError(objResult.ErrorMessage);
                    return false;
                }
                else {
                    displayResults(objResult);
                }
            })
            .fail(function (xhr, textStatus, errorThrown) {
                HideWait();
                //call didn't succeed.
                ShowError("Something went wrong, please try again later");
            });
        return false;
    });


};

//display refund search results.
function displayResults(objResult) {
    $("#orderNumResults").empty();

    //create instructions.
    var pInstructions = document.createElement('p');
    pInstructions.innerHTML = '<em>Check the box that is next to the product(s) that you want to return then click on Request Refund.</em>';
    $("#orderNumResults").append(pInstructions);

    //create header row 
    var rowDivHeader = CreateDiv("", "row", "rowHeader");

    // create title header div
    var titleHeaderDiv = CreateDiv("", "flex-child", "c50");
    var titleHeader = document.createElement("P");
    titleHeader.setAttribute("class", "mb-0 pb-1");
    titleHeader.innerHTML = "<strong>Title</strong>";
    titleHeaderDiv.appendChild(titleHeader);
    rowDivHeader.appendChild(titleHeaderDiv);


    // create code header div
    var codeHeaderDiv = CreateDiv("", "flex-child", "c30");
    var codeHeader = document.createElement("P");
    codeHeader.setAttribute("class", "mb-0 pb-1");
    codeHeader.innerHTML = "<strong>Code</strong>";
    codeHeaderDiv.appendChild(codeHeader);
    rowDivHeader.appendChild(codeHeaderDiv);

    // create refundstatus header div
    var refundStatusHeaderDiv = CreateDiv("", "flex-child", "pl-4");
    var refundStatusHeader = document.createElement("P");
    refundStatusHeader.setAttribute("class", "mb-0 pb-1");
    refundStatusHeader.innerHTML = "<strong>Refund Eligibility</strong>";

    refundStatusHeaderDiv.appendChild(refundStatusHeader);
    rowDivHeader.appendChild(refundStatusHeaderDiv);

    var hasEligiblePdcts = false;

    $("#orderNumResults").append(rowDivHeader);
    //create table.
    for (var item = 0; item < objResult.length; item++) {
        // create products row divs
        var rowDiv = CreateDiv("", "row", "productResult");

        var ebookCode = objResult[item]["Code"];

        var itemId = objResult[item]["LineItemId"];
        var orderName = objResult[item]["OrderName"];
        var orderId = objResult[item]["OrderId"];
        var refundItem = orderId + "_" + itemId.toString() + "_" + orderName + "_" + ebookCode;

        var checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.id = refundItem;
        checkbox.name = 'refund';
        checkbox.value = refundItem;

        // check if eligible for refund
        var refundEligible = "";
        if (objResult[item]["RefundEligible"]) {
            refundEligible = "Eligible";
            hasEligiblePdcts = true;
        } else {
            refundEligible = "Not Eligible";
        }

        // create title row divs
        var pdctTitle = objResult[item]["Title"];
        var titleDiv = CreateDiv("", "flex-child", "c50");
        var titleLabel = document.createElement('label');
        titleLabel.htmlFor = ebookCode;
        titleLabel.appendChild(document.createTextNode(pdctTitle));
        titleLabel.setAttribute('class', 'faq-label');
        if (refundEligible == "Eligible") {
            titleDiv.appendChild(checkbox);
        }
        titleDiv.appendChild(titleLabel);
        rowDiv.appendChild(titleDiv)

        // create code row divs
        var codeDiv = CreateDiv("", "flex-child", "c30");
        var code = document.createElement("P");
        var codeText = document.createTextNode(ebookCode);
        code.appendChild(codeText);
        codeDiv.appendChild(code);
        rowDiv.appendChild(codeDiv)

        // create refund div
        var refundDiv = CreateDiv("", "flex-child", "pl-4");
        var refund = document.createElement("P");
        var refundText = document.createTextNode(refundEligible);
        refund.appendChild(refundText);
        refundDiv.appendChild(refund);
        rowDiv.appendChild(refundDiv)
        $("#orderNumResults").append(rowDiv);
    }


    //create submit button. 
    var btnRowDiv = CreateDiv("", "row");
    var btnDiv = CreateDiv("", "flex-child", "c30");
    var btn = document.createElement("button");
    btn.innerHTML = "Request Refund";
    btn.setAttribute('class', 'btn btn--primary btn--sm');
    btn.setAttribute('id', 'btnProcessRefund');
    btn.setAttribute("onclick", "processRefund();")
    btnDiv.appendChild(btn);
    btnRowDiv.appendChild(btnDiv);
    $("#orderNumResults").append(btnRowDiv);


    $("#orderNumResults").removeClass("hidden");
    $('html,body').animate({ scrollTop: $("#ebookRefundPolicy").offset().top-200 });
}

//process refund.
function processRefund() {

    //disable the refund button.
    $("#btnProcessRefund").attr("disabled", true);

    //get the ebooks that should be refunded.
    var selected = [];
    $('input:checkbox[name=refund]').each(function () {
        if ($(this).is(':checked'))
            selected.push($(this).val());
    });

    //display error if there is no ebook that is selected.
    if (selected.length == 0) {
        ShowError("You must select at least one Ebook.");
        return false;
    }


    //start the refund process.
    PleaseWait();
    var selectedJson = JSON.stringify(selected);
    console.log(selectedJson);

    $.ajax({
        type: "Get",
        url: "https://dnext.humankinetics.com/Shopify/FAQs/refund/process?orderdetails=" + selectedJson,
        contentType: "text/javascript",
        crossDomain: true,
        timeout: 180000, //will timeout after 3 minutes
        xhrFields: { withCredentials: true }
    })
        .done(function (data) {
            HideWait();
            if (data.toLowerCase() == "success") {
                var result = "<p class='feedbackMsg'>Your refund has been processed. Please allow 7-10 business days for your credit card to reflect the refund.</p>" +
                    "<p class='feedbackMsg'><i class='fa fa-check' style='font-size:20px;color:green'></i>A refund confirmation email has been sent to the email that was used to purchase the Ebook.</p>" +
                    "<p class='feedbackMsg'><i class='fa fa-check' style='font-size:20px;color:green'></i>Your access to the Ebook has been revoked.</p>" +
                    "<p class='feedbackMsg'><a href='/'>Continue Shopping</a></p>";
                ShowError(result);
                return false;
            }
            else {
                var errMsg = "<p class='feedbackMsg'>Oops someting went wrong.</p>" +
                    "<p class='feedbackMsg'>We have been notified of the error and will process your refund ASAP</p>" +
                    "<p class='feedbackMsg'><a href='/pages/contact-information'>Contact us</a></p>";
                ShowError(errMsg);

                return false;
            }
        })
        .fail(function (xhr, textStatus, errorThrown) {
            console.log(xhr);
            console.log(textStatus);
            console.log(errorThrown);
            HideWait();
            //call didn't succeed.
        });

    return false;

}

